import { h, Component } from "preact";
import { route } from "preact-router";
import linkState from 'linkstate';
import { getApiPath } from "../../../../path";

import AdminMenu from "../../../../components/admin/menu";
import Editor from "../../../../components/admin/editor";

class AdminEditUser extends Component {
  state = {
    dblist: [],
    formSubmitted: false,
    formValid: false,
    formData: {
      actief: false,
      username: "",
      voornaam: "",
      tussenvoegsel: "",
      achternaam: "",
      over: "",

      id_roles: "",
      access: [],

      password: "",
      confirmPassword: ""
    }
  };

  constructor(props) {
    super(props);
    this.editorHandler = this.editorHandler.bind(this);
    this.ApiGetInfo();
  }

  editorHandler(name, newContent) {
    this.state.formData[name] = newContent;
  }

  ApiGetInfo = () => {
    let fetchPath = getApiPath(this.props.lang, `user/profile/${this.props.id}`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        this.setState(previousState => ({
          ...previousState,
          formData: {
            actief: result.data["actief"] == 1 ? true : false,
            username: result.data["username"],
            voornaam: result.data["voornaam"],
            tussenvoegsel: result.data["tussenvoegsel"],
            achternaam: result.data["achternaam"],
            over: result.data["over"],

            id_roles: result.data["id_roles"],
            access: result.data["access"] != null ? result.data["access"] : [],

            password: "",
            confirmPassword: ""
          }
        }));
      }
    });

    fetchPath = getApiPath(this.props.lang, `menu`);
    fetch(fetchPath)
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        this.setState(previousState => ({
          ...previousState,
          dblist: result.data
        }));
      }
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.state.formData.access = Array.from(document.getElementById("access").selectedOptions).map(o => parseInt(o.value));

    this.setState(previousState => ({
      ...previousState,
      formSubmitted: true
    }), this.validateForm());
  }

  validateForm = () => {
    if ( // required fields
      this.state.formData.username == "" ||
      this.state.formData.voornaam == "" ||
      this.state.formData.achternaam == "" ||
      this.state.formData.id_roles == "" ||
      this.state.formData.access == ""
    ) {
      this.setState(previousState => ({
        ...previousState,
        formValid: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        formValid: true
      }), this.doSubmit());
    }
    // } else if (// password validate
    //   this.state.formData.password != "" &&
    //   this.state.formData.password != this.state.formData.confirmPassword
    // ) {
    //   return false;
    // }
  }

  doSubmit = () => {
    let fetchPath = getApiPath(this.props.lang, `user/profile/${this.props.id}`);
    fetch(fetchPath, {
      method: 'post',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
      body: JSON.stringify(this.state.formData)
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        if(this.isEditingSelf()){
          this.reloadSessionProfile();
        }else{
          route(`/${this.props.lang}/admin/users`);
        }
      } else {
        alert("Something went wrong");
      }
    });
  }

  reloadSessionProfile(){
    let fetchPath = getApiPath(this.props.lang, `user/myProfile`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
      .then(res => res.json())
      .then(result => {
        if (result.status == 200) {
          sessionStorage.setItem("vumc-profile", JSON.stringify(result.data));
          route(`/${this.props.lang}/admin/users`);
        } else {
          sessionStorage.removeItem("vumc-jwt");
          sessionStorage.removeItem("vumc-profile");
        }
      });
  }

  isEditingSelf() {
    return JSON.parse(sessionStorage.getItem("vumc-profile"))["id_account"] == this.props.id;
  }

  render() {
    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <div>
          <h2>{this.props.lang=='nl'? 'Bewerk gebruiker':'Edit user'}</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit}>
              <div class="form-group">
                <label for="actief">{ this.props.lang == 'nl' ? 'Actief?':'Active'}</label>
                <input type="checkbox" name="actief" id="actief" checked={this.state.formData.actief} onInput={linkState(this, 'formData.actief')}
                  disabled={this.isEditingSelf()} />
              </div>
              <div class="form-group">
                <label for="username">Username <span class="req">*</span></label>
                <input type="text" name="username" id="username" value={this.state.formData.username} onInput={linkState(this, 'formData.username')} />
              </div>
              <div class="form-group">
                <label for="voornaam">{ this.props.lang == 'nl' ? 'Voornaam':'First name'} <span class="req">*</span></label>
                <input type="text" name="voornaam" id="voornaam" value={this.state.formData.voornaam} onInput={linkState(this, 'formData.voornaam')} />
              </div>
              <div class="form-group">
                <label for="tussenvoegsel">{ this.props.lang == 'nl' ? 'Tussenvoegsel':'Middle name'}</label>
                <input type="text" name="tussenvoegsel" id="tussenvoegsel" value={this.state.formData.tussenvoegsel} onInput={linkState(this, 'formData.tussenvoegsel')} />
              </div>
              <div class="form-group">
                <label for="achternaam">{ this.props.lang == 'nl' ? 'Achternaam':'Surname'} <span class="req">*</span></label>
                <input type="text" name="achternaam" id="achternaam" value={this.state.formData.achternaam} onInput={linkState(this, 'formData.achternaam')} />
              </div>

              <div class="form-group">
                <label for="over">{this.props.lang=='nl'?'Over':'About'}</label>
                <Editor name="over" content={this.state.formData.over} afterChange={this.editorHandler} />
              </div>

              <div class="form-group">
                <label for="id_roles">Rol <span class="req">*</span></label>
                <select name="id_roles" id="id_roles" size="2" value={this.state.formData.id_roles} onInput={linkState(this, 'formData.id_roles')}>
                  <option value="1">Admin</option>
                  <option value="2">Editor</option>
                </select>
              </div>

              <div class="form-group">
                <label for="access">{this.props.lang=='nl'?'Toegang tot databases':'Access to databases'} <span class="req">*</span></label>
                <select name="access" id="access" size={this.state.dblist.length} multiple={true}>
                  {this.state.dblist.map(db => {
                    return (<option
                      selected={this.state.formData.access.findIndex(a => a == parseInt(db.id)) != -1}
                      value={db.id}>{db.label}
                    </option>);
                  })}
                </select>
              </div>

              <div class="form-group">
                <em>{this.props.lang=='nl'?'Onderstaande wachtwoord velden alleen invullen als wachtwoord gewijzigd moet worden &oacute;f als de gebruiker aangemaakt worden':'Only fill in the password fields below if the password needs to be changed or if the user needs to be created.'}</em>
                <label for="password">{this.props.lang=='nl'?'Nieuw wachtwoord':'New password'}</label>
                <input type="password" name="password" id="password" autocomplete="off" value={this.state.formData.password} onInput={linkState(this, 'formData.password')} />
              </div>
              <div class="form-group">
                <label for="confirmPassword">{this.props.lang=='nl'?'Bevestig nieuw wachtwoord':'Confirm new password'}</label>
                <input type="password" name="confirmPassword" id="confirmPassword" autocomplete="off" value={this.state.formData.confirmPassword} onInput={linkState(this, 'formData.confirmPassword')} />
              </div>
              
              {(this.state.formSubmitted && !this.state.formValid) &&
                <div class="form-group">
                    {this.props.lang=='nl'? 'Controleer of alle verplichte velden zijn ingevuld. Deze zijn gemarkeerd met' : 'Please check that all required fields are filled in. These are marked with' } <span class="req">*</span>
                </div>
              }

              <div class="form-group">
                <button>{this.props.lang=='nl'? 'Opslaan':'Save'}</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    );
  }
}

export default AdminEditUser;
